"use strict";exports.i=()=>"undefined"!=typeof window;